<template>
  <v-content id="login" color="transparent">
    <div>
      <img :src="this.languageImageUrl" class="languageImage">
    </div>
    <v-container fluid fill-height>
      <v-layout align-center justify-center row>
        <v-flex xs4>
          <v-card class="elevation-1 pa-3">
            <v-card-text>
              <div class="layout column align-center">
                <h1 class="flex primary--text">
                  <img src="static/images/logo.gif" style="width:30px; margin-bottom: 5px; margin-right: 10px;">
                  BMIoT-GOD
                </h1>
              </div>
              <v-form>
                <v-text-field
                  append-icon="person"
                  name="login"
                  label="Login"
                  type="text"
                  v-model="userEmail"
                  :error="error"
                  :rules="[rules.required]"
                />
                <v-text-field
                  :type="hidePassword ? 'password' : 'text'"
                  :append-icon="hidePassword ? 'visibility_off' : 'visibility'"
                  name="password"
                  label="Password"
                  id="password"
                  :rules="[rules.required]"
                  v-model="password"
                  :error="error"
                  @click:append="hidePassword = !hidePassword"
                />
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <!-- <v-btn block color="primary" class="text-white" @click="$router.push(`/main_menu/battery_pack_list`)" :loading="loading">Login</v-btn> -->
              <v-btn
                block
                color="primary"
                class="text-white"
                @click="login()"
                :loading="loading"
              >Login</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-snackbar v-model="showResult" :timeout="2000" top>{{ LoginError }}</v-snackbar>
  </v-content>
</template>

<script>
import mediator from "../../components/common/mediator.vue";

export default {
  name: "Login",
  mixins: [mediator],
  mounted() {
    this.setServerLanguage();

    this.subscriber("GetServerLanguage", this.getServerLanguage, this);
  },
  data() {
    const $t = this.$t.bind(this);

    return {
      loading: false,
      userEmail: "",
      password: "",
      hidePassword: true,
      error: false,
      showResult: false,
      rules: {
        required: value => !!value || "Required."
      },
      LoginError: $t("BatteryPackList.Message.LoginError"),
      languageImageUrl: '',
      currentServerLang: ''
    };
  },

  methods: {
    login() {
      if (!this.userEmail || !this.password) {
        return;
      }

      const vm = this;
      vm.loading = true;
      
      let params = new URLSearchParams();
      params.append("account", vm.userEmail);
      params.append("password", vm.password);

      this.axios
        .post(`${vm.$root.url}/Auth`, params)
        .then(response => {
          vm.$root.user = response.data.name;
          vm.$root.type = response.data.type;
          vm.$root.assign = response.data.assign;
          vm.$root.token = response.data.token;

          vm.$router.push("/main_menu/battery_pack_list");
        })
        .catch(error => {
          const $t = this.$t.bind(this);
          vm.error = true;
          vm.showResult = true;
          vm.loading = false;
        });
    },
    setServerLanguage() {
      let self = this;

      self.axios
        .get(`${self.$root.url}/Common/CurrentCulture`, {
          headers: {
            Authorization: `Bearer ${this.$root.token}`
          }
        })
        .then(response => {
          if(response) {
            self.currentServerLang = response.data.culture;
            switch(self.currentServerLang) {
              case 'ja-JP':
                self.languageImageUrl = 'static/images/jp.png';
                break;
              case 'zh-CN':
                self.languageImageUrl = 'static/images/ch.png';
                break;
            }
          }
        });
    },
    getServerLanguage() {
      return this.currentServerLang;
    }
  }
};
</script>

<style scoped lang="css">
  #login {
    height: 50%;
    width: 100%;
    /* position: absolute;
    top: 0;
    left: 10%; */
    content: "";
    z-index: 0; 
    margin: 0 auto;
  }
  .text-white {
    color: white;
  }
  .languageImage {
    position: absolute;
    right: 20px;
    top: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/router/Customer/Login.vue